/**
 * Returns the brand name from a medication label, stripping the trailing
 * dose / unit / form / presentation suffix that regulatory names carry.
 *
 * `"GONAL-F 150 UI/0,24 mL, solution injectable en stylo prérempli, ..."`
 *   → `"GONAL-F"`
 * `"Menopur 75 UI poudre, solution injectable"` → `"Menopur"`
 * `"Letrozole 2.5 mg comprimé"` → `"Letrozole"`
 *
 * Strategy: take everything before the first whitespace that is followed by
 * a digit. If the label has no numeric suffix, split on the first comma so
 * we don't carry the form/presentation tail. If neither applies, return the
 * input unchanged.
 */
export function extractMedicationShortName(
  fullLabel: string | null | undefined,
): string {
  if (!fullLabel) return "";
  const trimmed = fullLabel.trim();
  if (!trimmed) return "";

  const beforeDose = trimmed.match(/^(.+?)\s+\d/);
  if (beforeDose?.[1]) {
    return beforeDose[1].trim();
  }
  const commaIndex = trimmed.indexOf(",");
  if (commaIndex > 0) {
    return trimmed.slice(0, commaIndex).trim();
  }
  return trimmed;
}
